import { FC, MouseEventHandler } from 'react';

import { useTheme } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { useMediaQuery } from '~/common/hooks/use-media-query';

import { Button } from '../Button';

interface IIconButtonProps {
  hint?: string;
  icon: string;
  backgroundColor?: string;
  textOrIconColor?: string;
  borderColor?: string;
  disabled?: boolean;
  withLinearGradientBorder?: boolean;
  href?: string;
  small?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const IconButton: FC<IIconButtonProps> = ({
  hint,
  icon,
  backgroundColor,
  textOrIconColor,
  borderColor,
  withLinearGradientBorder = true,
  small = false,
  disabled = false,
  href,
  onClick,
}) => {
  const mobile = useMediaQuery('(max-width: 750px)');
  const theme = useTheme();
  return (
    <Button
      justifyContent="center"
      href={href}
      withLinearGradientBorder={withLinearGradientBorder}
      height={small ? (mobile ? '28' : '24') : mobile ? '40' : '36'}
      width={small ? (mobile ? '28' : '24px') : mobile ? '40px' : '36px'}
      icon={icon}
      backgroundColor={backgroundColor || hexToRgba(theme.green[500], 0.25)}
      borderColor={borderColor || theme.transparent}
      textOrIconColor={textOrIconColor || theme.green[500]}
      iconSize={small ? 16 : 24}
      tooltip={hint}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
